import type { FaireProductEntity } from "../../entity_types/product";

export const p_vc52crbh5m: FaireProductEntity = {
  token: "p_vc52crbh5m",
  type: "product",
  name: "Spike the Canned Triceratops Dinosaur Plush w/Funny Jokes",
  brandToken: "b_d2r2bs3j23",
  brandName: "Canned Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/b420aaa511c131bdee60e7ec3b5e9fd019c98aa722d7370667f031b7a3766f51.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fefda02618b6ebaf49db7540afb73c0f2036fba82aabd3533eb2fc2bca6bc538.png",
    "https://cdn.faire.com/fastly/16a9bd0799842029a8799ea50fdc9ced08a13cdad89acc78f550793f1c0030bf.png",
    "https://cdn.faire.com/fastly/65981303e2ae167fb64a7247e30e4c0b7c9930a525fb502467dcf16ba2415d96.png",
    "https://cdn.faire.com/fastly/d0f0261af9a4d4412b075e31184c378845e688130c929d6383ceb49203ec94b8.png",
    "https://cdn.faire.com/fastly/dcf8fdbf5bcefa6caa771b1657aa4d5e84c1b1475c3b77e66642494a29559208.png",
    "https://cdn.faire.com/fastly/c86dc6e462695ddb945dd37d6f829bcf4550a97690695601ad7a12e2fc852c22.png",
  ],
  priceDollars: 13.86,
  description:
    "Meet Spike the Canned Triceratops!\nThese are super fun and popular with gift shops and novelty and boutique shops!\n•\tTriceratops dinosaur plush sealed in a soup can. Use a can opener to open the fun gift or choose a pop top lid!\n•\tPlush measures approx. 5 inches each.\n•\tFunny dinosaur jokes and an interesting fact on the can.\n•\tDesigned and canned in the USA. Can and label made in USA. Plush made in China.\n\nFew people can say they've received a Canned Triceratops before!  Makes a great gift for the person who is hard to buy for, or kid's birthday parties.\n\nstuffed animals gifts mothers day kids toys mother's day mom mens gifts summer teacher appreciation gifts fathers day gifts birthday kids birthday toys for kids minnesota texas pets unique gifts colorado dog mom spring decor\n\n*Testers are a open can with the plush prepared for display",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:27.065Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
